import { render, staticRenderFns } from "./SusulanPromo.vue?vue&type=template&id=7012d331&"
import script from "./SusulanPromo.vue?vue&type=script&lang=js&"
export * from "./SusulanPromo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports